<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"></p>
<p class="block_1">Gangster Love</p>
<p class="block_">By J.T. Marie</p>
<p class="block_">Published by <a class="text_" href="http://www.jms-books.com" target="_blank">JMS Books LLC</a> </p>
<p class="block_">Visit <a class="text_" href="http://www.jms-books.com" target="_blank">jms-books.com</a> for more information.</p>
<p class="block_">Copyright 2011 J.T. Marie </p>
<p class="block_">ISBN 978-1-61152-139-9</p>
<p class="block_2">* * * *</p>
<p class="block_3">Cover Design: <a class="text_" href="http://www.written-ink.com" target="_blank">Written Ink Designs</a> | written-ink.com</p>
<p class="block_3">Image(s) used under a Standard Royalty-Free License.</p>
<p class="block_3">All rights reserved.</p>
<p class="block_4">WARNING: This book is not transferable. It is for your own personal use. If it is sold, shared, or given away, it is an infringement of the copyright of this work and violators will be prosecuted to the fullest extent of the law.</p>
<p class="block_4">No portion of this book may be transmitted or reproduced in any form, or by any means, without permission in writing from the publisher, with the exception of brief excerpts used for the purposes of review.</p>
<p class="block_4">This is a work of fiction. Names, characters, places and incidents are solely the product of the author's imagination and/or are used fictitiously, though reference may be made to actual historical events or existing locations. Any resemblance to actual persons, living or dead, is entirely coincidental.</p>
<p class="block_4">Published in the United States of America. </p>
<p class="block_2">* * * *</p>
<p class="block_1">Gangster Love</p>
<p class="block_">By J.T. Marie</p>
<p class="block_5">Table of Contents</p>
<ol class="list_">
<li class="block_6"><a class="text_" href="#/#id_twooutlaws">Two Outlaws</a></li>
<li class="block_6"><a class="text_" href="#/#id_awake">Awake</a></li>
<li class="block_6"><a class="text_" href="#/#id_billy1">Billy #1</a></li>
<li class="block_6"><a class="text_" href="#/#id_wantedman">Wanted Man</a></li>
<li class="block_6"><a class="text_" href="#/#id_thisoutlawgig">This Outlaw Gig</a></li>
<li class="block_6"><a class="text_" href="#/#id_cocksure">Cocksure</a></li>
<li class="block_6"><a class="text_" href="#/#id_billy2">Billy #2</a></li>
<li class="block_6"><a class="text_" href="#/#id_northbound">Northbound</a></li>
<li class="block_6"><a class="text_" href="#/#id_billy3">Billy #3</a></li>
<li class="block_6"><a class="text_" href="#/#id_billy4">Billy #4</a></li>
<li class="block_6"><a class="text_" href="#/#id_billy5">Billy #5</a></li>
<li class="block_6"><a class="text_" href="#/#id_gangsterlove">Gangster Love</a></li>
<li class="block_6"><a class="text_" href="#/#id_bonnieandclyde">Bonnie and Clyde</a></li>
<li class="block_6"><a class="text_" href="#/#id_billy6">Billy #6</a></li>
<li class="block_6"><a class="text_" href="#/#id_asifiwould">As If I Would</a></li>
<li class="block_6"><a class="text_" href="#/#id_innocencelost">Innocence Lost</a></li>
<li class="block_6"><a class="text_" href="#/#id_bullet">Bullet</a></li>
<li class="block_6"><a class="text_" href="#/#id_thatday">That Day</a></li>
<li class="block_6"><a class="text_" href="#/#id_bloodanddreams">Blood and Dreams</a></li>
<li class="block_6"><a class="text_" href="#/#id_everagain">Ever Again</a></li>
<li class="block_6"><a class="text_" href="#/#id_fall">Fall</a></li>
<li class="block_6"><a class="text_" href="#/#id_inthedark">In the Dark</a></li>
<li class="block_6"><a class="text_" href="#/#id_closemythroat">Close My Throat</a></li>
<li class="block_6"><a class="text_" href="#/#id_back">Back</a></li>
</ol>
<p class="block_2">* * * *</p>
<h1 class="block_7" id="id_twooutlaws">Two Outlaws</h1>
<p class="block_3">We used to run together</p>
<p class="block_3">Two outlaws running free</p>
<p class="block_3">But now a steely lawman's</p>
<p class="block_3">Replaced the outlaw you used to be</p>
<p class="block_3">And the friend you were to me.</p>
<p class="block_2">* * * *</p>
<h1 class="block_7" id="id_awake">Awake</h1>
<p class="block_3">I lie here, awake,</p>
<p class="block_3">in the arms of another transient lover,</p>
<p class="block_3">thinking of you.</p>
<p class="block_3">Once we were closer than brothers;</p>
<p class="block_3">now every night I listen, straining to hear</p>
<p class="block_3">the distant thunder of your guns.</p>
<p class="block_3">I know they point through the darkness,</p>
<p class="block_3">their bolts of lightning flashing my name,</p>
<p class="block_3">each shot aimed at my heart.</p>
<p class="block_3">I lie here, awake,</p>
<p class="block_3">a frightened animal hunched</p>
<p class="block_3">before your torrential storm.</p>
<p class="block_2" id="id_Toc296635134">* * * *</p>
<h1 class="block_7" id="id_billy1">Billy #1</h1>
<p class="block_3">This is something I don't want to do.</p>
<p class="block_3">You think this is easy for me?</p>
<p class="block_3">After all the times we've had,</p>
<p class="block_3">all the days in the saddle,</p>
<p class="block_3">all the nights by your fire?</p>
<p class="block_3">You think I can just throw away that life </p>
<p class="block_3">like knocking the dust from my heels,</p>
<p class="block_3">everything we did together,</p>
<p class="block_3">everything left to do?</p>
<p class="block_3">It's the money I need, the stability,</p>
<p class="block_3">the clearing of my name.</p>
<p class="block_3">But I want you to know</p>
<p class="block_3">if I could change this course I'm on,</p>
<p class="block_3">I would. If I could</p>
<p class="block_3">kill anyone else and let you go free,</p>
<p class="block_3">believe me, Billy,</p>
<p class="block_3">I would.</p>
<p class="block_2" id="id_Toc296635135">* * * *</p>
<h1 class="block_7" id="id_wantedman">Wanted Man</h1>
<p class="block_3">Sometimes I just want to lie down where I am</p>
<p class="block_3">and wait for them to catch me.</p>
<p class="block_3">But what good would that do?</p>
<p class="block_3">Where would I be?</p>
<p class="block_3">The same place I am now--</p>
<p class="block_3">alone, lonely, lost,</p>
<p class="block_3">without you.</p>
<p class="block_3">What's the use?</p>
<p class="block_3">The roads are too dangerous if I stay on them</p>
<p class="block_3">for too long. How many lives have I ruined</p>
<p class="block_3">by casual theft? Not enough.</p>
<p class="block_3">Not enough</p>
<p class="block_3">to make up for their theft of you.</p>
<p class="block_3">Perhaps if you were "safe" somewhere,</p>
<p class="block_3">under lock and key,</p>
<p class="block_3">it would be easier for me.</p>
<p class="block_3">I know stone walls do not a prison make</p>
<p class="block_3">unless those walls are</p>
<p class="block_3">made of wood and buried</p>
<p class="block_3">six feet under.</p>
<p class="block_3">Where I should be.</p>
<p class="block_3">The worst part is I didn't get to say goodbye.</p>
<p class="block_3">You told me to run</p>
<p class="block_3">and I ran,</p>
<p class="block_3">believing you behind me.</p>
<p class="block_3">I didn't even know you were gone until</p>
<p class="block_3">I crept back to that inconvenience store</p>
<p class="block_3">under cover of darkness and</p>
<p class="block_3">driving rain only to find you</p>
<p class="block_3">etched in chalk,</p>
<p class="block_3">brilliant under brilliant lights</p>
<p class="block_3">and beginning to run in the rain.</p>
<p class="block_3">Now every car looks alike, every license plate</p>
<p class="block_3">reads to me another day I'm</p>
<p class="block_3">Not with them</p>
<p class="block_3">Not with you</p>
<p class="block_3">Alone.</p>
<p class="block_3">Everyone who stares too long </p>
<p class="block_3">at my poster-perfect face</p>
<p class="block_3">convinces me to follow</p>
<p class="block_3">your dying command.</p>
<p class="block_3">I've been running on empty too long now</p>
<p class="block_3">a wanted man.</p>
<p class="block_3">Sleep is a stranger to me--the only</p>
<p class="block_3">night I see is that eternal one</p>
<p class="block_3">your beautiful eyes are closed on.</p>
<p class="block_3">At my back I hear</p>
<p class="block_3">death's insidious whisper.</p>
<p class="block_3">I can't outrace the sun-- there are</p>
<p class="block_3">few hiding places left</p>
<p class="block_3">as yet unspoiled</p>
<p class="block_3">by my bloody tears.</p>
<p class="block_3">I have only two bullets left--one</p>
<p class="block_3">for the lawman who pulled your noose too tight, and one</p>
<p class="block_3">for me--my ticket to you.</p>
<p class="block_2" id="id_Toc296635136">* * * *</p>
<h1 class="block_7" id="id_thisoutlawgig">This Outlaw Gig</h1>
<p class="block_3">A bottle of magic bought at a grocery store with a small bill</p>
<p class="block_3">and twenty minutes later a new me rises in the cloudy mirror</p>
<p class="block_3">of a dingy gas station bathroom.</p>
<p class="block_3">In another town, in the grip of fear, I go to the mall</p>
<p class="block_3">and as they sweep up the dyed ends of my cut hair, I drive away.</p>
<p class="block_3">No one could recognize me now.</p>
<p class="block_3">I don't even have an ID that looks like me.</p>
<p class="block_3">The next state over, I get pulled for speeding</p>
<p class="block_3">but the car is stolen and without registration</p>
<p class="block_3">I shoot the officer and peel away--</p>
<p class="block_3">I'm getting good at this outlaw gig.</p>
<p class="block_3">Soon I grow tired of driving, of running,</p>
<p class="block_3">but there's no where left to go</p>
<p class="block_3">when half a million dollars begins to drag you down.</p>
<p class="block_2" id="id_Toc296635137">* * * *</p>
<h1 class="block_7" id="id_cocksure">Cocksure</h1>
<p class="block_3">Cocksure, you swagger into the cantina,</p>
<p class="block_3">full of yourself, hot from the heat of battle</p>
<p class="block_3">and proud...unbearably proud.</p>
<p class="block_3">I loathe you and your sureness, your ease</p>
<p class="block_3">as you sidle up to the bar, royalty</p>
<p class="block_3">and not your everyday, common gunslinger.</p>
<p class="block_3">I loathe your boastful voice, your roaming hands,</p>
<p class="block_3">your arrogant eyes.</p>
<p class="block_3">I don't know whether to wrap my arms</p>
<p class="block_3">around your neck and strangle the life from you, or</p>
<p class="block_3">sweep you into a strong embrace and never let you go.</p>
<p class="block_3">Your wildness excites me and </p>
<p class="block_3">I loathe myself for that.</p>
<p class="block_3">Later, in the kitchen, I scrub the pots with angry hands</p>
<p class="block_3">and hate myself as I listen out for the sound of your voice.</p>
<p class="block_3">When it whispers in my ear, a hot breath from the desert,</p>
<p class="block_3">I flush from your closeness, your hands</p>
<p class="block_3">not quite touching my waist, your body</p>
<p class="block_3">not quite pressed against mine.</p>
<p class="block_3">I loathe my reaction.</p>
<p class="block_3">But my brusqueness doesn't put you off for here,</p>
<p class="block_3">at last, stands the one cook's boy </p>
<p class="block_3">who doesn't fall in the wake of your passing,</p>
<p class="block_3">who doesn't stumble over himself to bend over for you.</p>
<p class="block_3">My eyes widen in surprise at your confidence</p>
<p class="block_3">when your smoldering lips close over mine.</p>
<p class="block_3">I hate myself for not</p>
<p class="block_3">pulling away.</p>
<p class="block_2" id="id_Toc296635138">* * * *</p>
<h1 class="block_7" id="id_billy2">Billy #2</h1>
<p class="block_3">I never told a man I loved him.</p>
<p class="block_3">My father wouldn't take such sissy talk,</p>
<p class="block_3">said it won't becoming to admit to having</p>
<p class="block_3">such an emotion toward another man.</p>
<p class="block_3">He would've thought it improper, not right.</p>
<p class="block_3">Love's a word confined to the bedroom</p>
<p class="block_3">and only then used to get her clothes off.</p>
<p class="block_3">But my father never ran with you,</p>
<p class="block_3">never felt the strength in your arm or the fire in your grip</p>
<p class="block_3">when I fell off my horse and you pulled me onto yours.</p>
<p class="block_3">He never feared every sound by night,</p>
<p class="block_3">every hoof beat in the distance,</p>
<p class="block_3">every gunshot in the morning's light.</p>
<p class="block_3">Mayhap I love you, Billy,</p>
<p class="block_3">as much as one man can another.</p>
<p class="block_3">And I'd die for you, Billy,</p>
<p class="block_3">if it was up to me.</p>
<p class="block_3">But it ain't up to me</p>
<p class="block_3">and it's awful hard to protect you</p>
<p class="block_3">when it's my finger on the trigger</p>
<p class="block_3">and my eye through the sights.</p>
<p class="block_3">But I still love you.</p>
<p class="block_3">So much so no one else</p>
<p class="block_3">should have the right </p>
<p class="block_3">to kill you but me.</p>
<p class="block_2" id="id_Toc296635139">* * * *</p>
<h1 class="block_7" id="id_northbound">Northbound</h1>
<p class="block_3">northbound</p>
<p class="block_3">eyes burning as driving rain</p>
<p class="block_3">washes the dusty windshield clean</p>
<p class="block_3">northbound</p>
<p class="block_3">radio so low I can't make out</p>
<p class="block_3">sad words drenched with rain</p>
<p class="block_3">northbound</p>
<p class="block_3">night so dark my high-beams</p>
<p class="block_3">aren't strong enough to light the way</p>
<p class="block_3">northbound</p>
<p class="block_3">without you because I don't know</p>
<p class="block_3">at this speed where you're headed now</p>
<p class="block_2" id="id_Toc296635140">* * * *</p>
<h1 class="block_7" id="id_billy3">Billy #3</h1>
<p class="block_3">The river is lined with sagebrush that easily hides</p>
<p class="block_3">a hundred men or more,</p>
<p class="block_3">all hungry for my blood</p>
<p class="block_3">and the money it'll bring.</p>
<p class="block_3">But not a drop of it shed is mine,</p>
<p class="block_3">and the red clay drinks their worthless share</p>
<p class="block_3">when I draw their blood first</p>
<p class="block_3">in a battle I didn't begin.</p>
<p class="block_3">The game goes on,</p>
<p class="block_3">across expanses as broad as the back of God</p>
<p class="block_3">and boom towns crowded with whores</p>
<p class="block_3">queened for the night I share their beds,</p>
<p class="block_3">love 'em and leave 'em, </p>
<p class="block_3">saddling up with my men before </p>
<p class="block_3">the coming of the dawn or</p>
<p class="block_3">the coming of the law.</p>
<p class="block_2" id="id_Toc296635143">* * * *</p>
<h1 class="block_7" id="id_gangsterlove">Gangster Love</h1>
<p class="block_3">It's time like these,</p>
<p class="block_3">when the sky darkens</p>
<p class="block_3">with the approach of night</p>
<p class="block_3">and the crickets grow silent,</p>
<p class="block_3">that I let myself believe</p>
<p class="block_3">everything will turn out all right.</p>
<p class="block_3">But when you're hit</p>
<p class="block_3">by a stray bullet,</p>
<p class="block_3">it takes much more</p>
<p class="block_3">than a kiss to stop</p>
<p class="block_3">the blood from flowing.</p>
<p class="block_3">One day, one of those bullets</p>
<p class="block_3">will stop our beating hearts.</p>
<p class="block_3">But I know, lying here</p>
<p class="block_3">curled against you, that</p>
<p class="block_3">no bullet could ever stop</p>
<p class="block_3">our gangster love.</p>
<p class="block_2" id="id_Toc296635144">* * * *</p>
<h1 class="block_7" id="id_bonnieandclyde">Bonnie and Clyde</h1>
<p class="block_3">If you were running,</p>
<p class="block_3">your life on the line,</p>
<p class="block_3">I'd be there beside you,</p>
<p class="block_3">Bonnie to your Clyde,</p>
<p class="block_3">and when the car slowed</p>
<p class="block_3">the guns cocked and aimed,</p>
<p class="block_3">I would hold your hand in mine</p>
<p class="block_3">as we went down in flames.</p>
<p class="block_2" id="id_Toc296635146">* * * *</p>
<h1 class="block_7" id="id_asifiwould">As If I Would</h1>
<p class="block_3">alone in the dark</p>
<p class="block_3">I whisper your name</p>
<p class="block_3">an almost religious word</p>
<p class="block_3">almost reluctantly</p>
<p class="block_3">I'm certain if the winds outside</p>
<p class="block_3">died down you'd hear me</p>
<p class="block_3">you'd come running</p>
<p class="block_3">you'd hear me whisper </p>
<p class="block_3">your name in the darkness</p>
<p class="block_3">you're waiting to hear it</p>
<p class="block_3">you'd track me down</p>
<p class="block_3">before I even had a chance</p>
<p class="block_3">to hide from you.</p>
<p class="block_3">as if I would.</p>
<p class="block_2" id="id_Toc296635141">* * * *</p>
<h1 class="block_7" id="id_billy4">Billy #4</h1>
<p class="block_3">the open trail leads me home</p>
<p class="block_3">any town where I'm known</p>
<p class="block_3">loved by whores, worshipped by children,</p>
<p class="block_3">feared and hated (and idolized) by men</p>
<p class="block_3">infamy, fame, it's all the same</p>
<p class="block_3">I will never be broken</p>
<p class="block_3">as long as I believe </p>
<p class="block_3">what they say of me.</p>
<p class="block_2" id="id_Toc296635147">* * * *</p>
<h1 class="block_7" id="id_innocencelost">Innocence Lost</h1>
<p class="block_3">It was so long ago, and yet</p>
<p class="block_3">if I close my eyes I can still see him,</p>
<p class="block_3">hand upon his hip, cocky smile,</p>
<p class="block_3">dancing eyes, jeans dusty from the trail,</p>
<p class="block_3">hair disheveled, clothes askew.</p>
<p class="block_3">A young man, made so by fate,</p>
<p class="block_3">yet still a boy at heart</p>
<p class="block_3">where his hidden innocence resides,</p>
<p class="block_3">a ghost time has turned from</p>
<p class="block_3">killer to hero in my mind,</p>
<p class="block_3">making me nostalgic for a time I never knew,</p>
<p class="block_3"><i class="calibre1">his</i> time, his life, his love,</p>
<p class="block_3">his innocence lost.</p>
<p class="block_2" id="id_Toc296635148">* * * *</p>
<h1 class="block_7" id="id_bullet">Bullet</h1>
<p class="block_3">In the dark I hear you call my name</p>
<p class="block_3">I know you're just as scared</p>
<p class="block_3">as I am</p>
<p class="block_3">just as scared</p>
<p class="block_3">perhaps even more so</p>
<p class="block_3">because you have to pull the trigger.</p>
<p class="block_3">I just have to take your bullet</p>
<p class="block_3">in my heart.</p>
<p class="block_2" id="id_Toc296635149">* * * *</p>
<h1 class="block_7" id="id_thatday">That Day</h1>
<p class="block_3">your freedom excites me</p>
<p class="block_3">and terrifies everyone else</p>
<p class="block_3">you live by a bullet</p>
<p class="block_3">but don't realize one day</p>
<p class="block_3">one of them</p>
<p class="block_3">will wear your name</p>
<p class="block_3">and leave my heart</p>
<p class="block_3">rent in two.</p>
<p class="block_3">we'll both die that day.</p>
<p class="block_2" id="id_Toc296635150">* * * *</p>
<h1 class="block_7" id="id_bloodanddreams">Blood and Dreams</h1>
<p class="block_3">banderilleros along the tree line</p>
<p class="block_3">around tracks covered with blood and dreams</p>
<p class="block_3">aiming across the river</p>
<p class="block_3">barrels pointing out your heart</p>
<p class="block_2" id="id_Toc296635151">* * * *</p>
<h1 class="block_7" id="id_everagain">Ever Again</h1>
<p class="block_3">an ocean of blue</p>
<p class="block_3">flowing behind</p>
<p class="block_3">your eyes</p>
<p class="block_3">alive with fear, excitement</p>
<p class="block_3">because you're not quite sure</p>
<p class="block_3">when you will die</p>
<p class="block_3">today may be the day</p>
<p class="block_3">and tomorrow I won't</p>
<p class="block_3">hold you</p>
<p class="block_3">ever again.</p>
<p class="block_2" id="id_Toc296635152">* * * *</p>
<h1 class="block_7" id="id_billy5">Billy #5</h1>
<p class="block_3">I didn't start this crazy war.</p>
<p class="block_3">Alone I sat out on the plain</p>
<p class="block_3">raiding for food until I met you</p>
<p class="block_3">a god in the guise of a man</p>
<p class="block_3">who shook the dust from my shirt</p>
<p class="block_3">and the burrs from my breeches.</p>
<p class="block_3">In you I saw salvation.</p>
<p class="block_3">In you I could begin to live again.</p>
<p class="block_3">That life started when</p>
<p class="block_3">they took yours too soon.</p>
<p class="block_3">I watched you die.</p>
<p class="block_3">Out of Hell's own fury I flew</p>
<p class="block_3">a raging whirlwind before which</p>
<p class="block_3">all trembled with fear, with hate, with lust.</p>
<p class="block_3">In revenge I dragged us together</p>
<p class="block_3">to bring your killers to a justice</p>
<p class="block_3">all my own.</p>
<p class="block_3">Now they shall reap</p>
<p class="block_3">only what they have sown.</p>
<p class="block_3">But when the war is over</p>
<p class="block_3">the whirlwind will still rage out there</p>
<p class="block_3">destroying all, devouring all.</p>
<p class="block_3">Now I'm caught up in it, I can't get out.</p>
<p class="block_3">Fame's a heady draught</p>
<p class="block_3">for a man who came from nothing.</p>
<p class="block_2">* * * *</p>
<h1 class="block_7" id="id_fall">Fall</h1>
<p class="block_3">sometimes I just want to</p>
<p class="block_3">fall</p>
<p class="block_3">but no one is willing</p>
<p class="block_3">to let me go.</p>
<p class="block_2" id="id_Toc296635153">* * * *</p>
<h1 class="block_7" id="id_inthedark">In the Dark</h1>
<p class="block_3">in the dark</p>
<p class="block_3">he doesn't see you</p>
<p class="block_3">hiding behind the door</p>
<p class="block_3">what does he think of</p>
<p class="block_3">as he edges into the room</p>
<p class="block_3">his eyes wide, wary</p>
<p class="block_3">does he sense you?</p>
<p class="block_3">does he know?</p>
<p class="block_3">and what crosses his mind</p>
<p class="block_3">when you jump out</p>
<p class="block_3">pin his arms behind him</p>
<p class="block_3">struggle to hold him down</p>
<p class="block_3">force him to admit defeat?</p>
<p class="block_3">the only thing you're thinking</p>
<p class="block_3">as you glare down into</p>
<p class="block_3">his frightened, upturned face</p>
<p class="block_3">is the black of his hair</p>
<p class="block_3">the feel of his flesh</p>
<p class="block_3">and you wonder what his lips</p>
<p class="block_3">would taste like against your own.</p>
<p class="block_2" id="id_Toc296635154">* * * *</p>
<h1 class="block_7" id="id_closemythroat">Close My Throat</h1>
<p class="block_3">the steps. someone</p>
<p class="block_3">somewhere miles away</p>
<p class="block_3">hands close my throat</p>
<p class="block_3">know that</p>
<p class="block_3">ring through me, here.</p>
<p class="block_3">running but not until now.</p>
<p class="block_3">Straining, I know if I can get back</p>
<p class="block_3">into another direction</p>
<p class="block_3">I would</p>
<p class="block_3">First shouts of the love</p>
<p class="block_3">of a</p>
<p class="block_3">bellows.</p>
<p class="block_2" id="id_Toc296635155">* * * *</p>
<h1 class="block_7" id="id_back">Back</h1>
<p class="block_3">the road is lonely</p>
<p class="block_3">so late at night</p>
<p class="block_3">I'm the only one out here</p>
<p class="block_3">it seems</p>
<p class="block_3">and my high beams </p>
<p class="block_3">aren't strong enough</p>
<p class="block_3">to pierce the blackness</p>
<p class="block_3">all I want to do</p>
<p class="block_3">is turn back</p>
<p class="block_3">the radio plays low</p>
<p class="block_3">I don't want to hear</p>
<p class="block_3">sad words on such a rainy night</p>
<p class="block_3">my wipers can't keep</p>
<p class="block_3">the glass clean</p>
<p class="block_3">it fogs as if with breath</p>
<p class="block_3">all I want to do</p>
<p class="block_3">is turn back</p>
<p class="block_3">back</p>
<p class="block_3">to an age of innocence</p>
<p class="block_3">when dreams always came true</p>
<p class="block_3">back</p>
<p class="block_3">to a security I no longer know</p>
<p class="block_3">a rebel without a clue</p>
<p class="block_3">back</p>
<p class="block_3">through the days</p>
<p class="block_3">the old comforting ways</p>
<p class="block_3">back</p>
<p class="block_3">when I could have been with you.</p>
<p class="block_3">now the trees loom</p>
<p class="block_3">darkly in the darkness</p>
<p class="block_3">descending over my life</p>
<p class="block_3">menacing, threatening, driving me</p>
<p class="block_3">onward deeper inside</p>
<p class="block_3">all I want to do</p>
<p class="block_3">is turn back</p>
<p class="block_3">but there are no u-turns</p>
<p class="block_3">in life, the exits all unmarked</p>
<p class="block_3">even if I stop to rest</p>
<p class="block_3">everyone else passes me by</p>
<p class="block_3">so I have to keep going</p>
<p class="block_3">onward forever</p>
<p class="block_3">without you yet</p>
<p class="block_3">all I want to do</p>
<p class="block_3">is turn back</p>
<p class="block_2" id="id_Toc296635145">* * * *</p>
<h1 class="block_7" id="id_billy6">Billy #6</h1>
<p class="block_3">I never loved another man</p>
<p class="block_3">the way I loved the outlaw in you.</p>
<p class="block_3">When you rode into town,</p>
<p class="block_3">hat cocked, smile loaded,</p>
<p class="block_3">guns ever at your side,</p>
<p class="block_3">eyes as wild as the prairie,</p>
<p class="block_3">I'd nod your way, unsmiling, terse,</p>
<p class="block_3">the staid picture of responsibility,</p>
<p class="block_3">as if every breath I took didn't bring</p>
<p class="block_3">the memory of your hands through my hair,</p>
<p class="block_3">the feel of your nails on my back,</p>
<p class="block_3">the grip of your legs locked around my hips</p>
<p class="block_3">as tight as the holster around your own.</p>
<p class="block_2">* * * *</p>
<p class="block_8">ABOUT J.T. MARIE</p>
<p class="block_4">J.T. Marie is a pseudonym for author J.M. Snyder, who publishes gay erotic and romantic fiction under her full name. A graduate of George Mason University, Marie worked as Fantasy Editor of the school's sci-fi and fantasy journal, <i class="calibre1">The Fractal</i>, for two years. After college, she created and maintained an online webzine, <i class="calibre1">Disenchanted</i>, to further a love of fantasy fiction. For more information on her non-gay fiction, nonfiction, and poetry, please visit <a class="text_" href="http://www.jtmarie.com/" target="_blank">jtmarie.com</a>. </p>
<p class="block_8"><img alt="jmsbooks" class="calibre2" src="images/image2.jpeg"/></p>
<p class="block_8">ABOUT JMS BOOKS LLC</p>
<p class="block_3">Founded in 2010, JMS Books LLC is owned and operated by author J.M. Snyder. We publish a variety of genres, including gay erotic romance, fantasy, young adult, poetry, and nonfiction. Short stories and novellas are available as e-books and compiled into single-author print anthologies, while any story over 30k in length is available in both print and e-book formats. Visit us at <a class="text_" href="http://www.jms-books.com/" target="_blank">jms-books.com</a> for our latest releases and submission guidelines!</p>
<p class="block_9"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?b827508a